// components/common/ModalShell.tsx
import React from 'react';
import { X } from 'lucide-react';

interface ModalShellProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    subtitle?: string;
    isProcessing?: boolean;
    children: React.ReactNode;
    footer?: React.ReactNode;
    maxWidth?: string;
    height?: string;
}

const ModalShell: React.FC<ModalShellProps> = ({
    isOpen,
    onClose,
    title,
    subtitle,
    isProcessing = false,
    children,
    footer,
    maxWidth = 'max-w-2xl',
    height = 'h-[600px] max-h-[90vh]',
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

            <div className={`relative bg-white rounded-xl shadow-2xl ${maxWidth} w-full ${height} overflow-hidden flex flex-col`}>
                {/* Header */}
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                    <div>
                        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        disabled={isProcessing}
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto p-6">{children}</div>

                {/* Footer */}
                {footer && (
                    <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ModalShell;